import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { PLATFORM_TRANSFERS_ROUTE_PATHS } from './config';

export const PLATFORM_TRANSFERS_ROUTES: TApplicationRoute[] = [
  {
    id: 'movements-platform-transfers',
    path: PLATFORM_TRANSFERS_ROUTE_PATHS.platformTransfers,
    component: lazy(() => import('./pages/platform-transfers-page')),
    layout: 'default',
    permissions: { scopes: ['movements-platform-transfers'] },
    menu: {
      title: 'Platform Transfers',
    },
  },
];
